import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import '@/assets/css/mediaSize.css'
import '@/assets/css/bess.css'

let Vue = createApp(App)

Vue.use(router)
Vue.use(store)
Vue.use(ElementPlus)

Vue.mount('#app')
